import React from 'react';

const PoweredByFooter = () => (
  <div className="hidden md:block">
    <footer className="border-t border-gray-100 dark:border-white/10 mt-12 py-5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-center items-center gap-2">
        <span className="text-xs text-gray-400 dark:text-gray-500">Powered by</span>
        <a
          href="https://www.tmplabs.ai/"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-1.5 hover:opacity-75 transition-opacity"
        >
          <img
            src="https://www.tmplabs.ai/icons/tmp-labs-icon-dark-transparent.png"
            alt="/tmp Labs"
            style={{ height: '20px', width: 'auto' }}
          />
          <span className="text-xs font-medium text-gray-500 dark:text-gray-400">/tmp Labs</span>
        </a>
      </div>
    </footer>
  </div>
);

export default PoweredByFooter;
